import { CmsApiEmailCampaignSignupSingleBlockData } from 'modules/cms/api/types/CmsApiEmailCampaignSignupSingle';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpEmailCampaignSignupSingleBlock({
  content,
  blockId,
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiEmailCampaignSignupSingleBlockData>) {
  return (
    <CmsAmpHeroBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        image: data.bgImage,
        text: data.headline,
        buttonText: data.buttonText,
        isEmailSignup: true,
      }}
    />
  );
}
